"use client";
import Button from "@/components/Cards/Button";
import ErrorModal from "@/components/ErrorModal";
import { TextInput } from "@/components/Inputs/TextInput";
import InfoModal from "@/components/Modal";
import Text from "@/components/Text/Text";
import { ButtonDark } from "@/stories/Button.stories";
import { Group, Radio } from "@mantine/core";
import { useForm, zodResolver } from "@mantine/form";
import { useState } from "react";
import { z } from "zod";

export default function FernbehandlungKundigenLayout({
    sendEmail,
}: {
    sendEmail: (subject: string, data: object) => Promise<void>;
}) {
    const schema = z.object({
        reason: z.string(),
        andrede: z.string(),
        name: z.string(),
        surname: z.string(),
        email: z
            .string()
            .email()
            .refine((value) => value.length > 0, {
                message: "Bitte gib eine gültige E-Mail-Adresse ein.",
            }),
    });
    const form = useForm({
        initialValues: {
            reason: "",
            andrede: "",
            name: "",
            surname: "",
            email: "",
        },
        validate: zodResolver(schema),
    });
    const [openModal, setOpenModal] = useState(false);
    const [error, setError] = useState(false);

    return (
        <>
            <form
                className="space-y-4"
                onSubmit={form.onSubmit((values) => {
                    const data = {
                        reason: values.reason,
                        andrede: values.andrede,
                        name: values.name,
                        surname: values.surname,
                        email: values.email,
                    };
                    sendEmail("Fernbehandlung Kündigen", data)
                        .then(() => {
                            setOpenModal(true);
                        })
                        .catch((e) => {
                            <ErrorModal open={error} onClose={() => setError(false)} />;
                        });
                })}
            >
                <TextInput
                    id="reason"
                    label="Welche Fernbegleitung möchtest Du künden?"
                    type="textarea"
                    name="reason"
                    placeholder="Hier eingeben"
                    {...form.getInputProps("reason")}
                />
                <div className="text-neutral-800 text-xl1 font-bold  leading-8.5">
                    Anrede
                </div>
                <Radio.Group
                    id="andrede"
                    name="andrede"
                    {...form.getInputProps("andrede")}
                >
                    <Group mt="xs">
                        <Radio value="Frau" label="Frau" />
                        <Radio value="Herr" label="Herr" />
                        <Radio value="Divers" label="Divers" />
                    </Group>
                </Radio.Group>
                <TextInput
                    id="name"
                    name="name"
                    type="text"
                    label="Vorname"
                    placeholder="Hier eingeben"
                    {...form.getInputProps("name")}
                />
                <TextInput
                    id="sunname"
                    name="surname"
                    type="text"
                    label="Nachname"
                    placeholder="Hier eingeben"
                    {...form.getInputProps("surname")}
                />
                <TextInput
                    id="email"
                    name="email"
                    type="text"
                    label="E-Mail"
                    placeholder="Hier eingeben"
                    {...form.getInputProps("email")}
                />
                <div className="flex justify-end">
                    <Button
                        buttonType="submit"
                        as="button"
                        hasIcon={ButtonDark.args?.hasIcon}
                        backgroundColor={ButtonDark.args?.backgroundColor}
                        size={ButtonDark.args?.size}
                        text=" Kündigung verbindlich senden"
                        textColor={ButtonDark.args?.textColor}
                        textSize={ButtonDark.args?.textSize}
                        paddings="py-3 lg:px-4"
                    />
                </div>
            </form>
            <InfoModal
                onClose={() => {
                    setOpenModal(false);
                }}
                opened={openModal}
                size="xl"
            >
                <Text
                    title="Vielen Dank!"
                    hasPretitle={false}
                    hasSubTitle={false}
                    hasText={true}
                    hasReadMore={false}
                    paddings=""
                    paragraphs={[
                        "Deine Nachricht wurde erfolgreich versendet. ",
                        "Anfragen werden in der Regel am selben Tag, spätestens innert 48 Stunden beantwortet. Am Wochenende und an Feiertagen lese ich die Anfragen, du erhältst aber keine Antwort.",
                        "Liebe Grüsse",
                        "Rico Brunner",
                    ]}
                />
                <div className="flex justify-end py-5">
                    <Button
                        hasIcon={ButtonDark.args?.hasIcon}
                        backgroundColor={ButtonDark.args?.backgroundColor}
                        size={ButtonDark.args?.size}
                        text="Home"
                        textColor={ButtonDark.args?.textColor}
                        textSize={ButtonDark.args?.textSize}
                        href="/"
                        as="a"
                    />
                </div>
            </InfoModal>
        </>
    );
}
